export default "__VITE_ASSET__d8138e48__"